import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { registerCodeHighlighting, CodeNode } from '@lexical/code';
import { useEffect } from 'react';

export default function CodeHighlightPlugin() {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    return registerCodeHighlighting(editor);
  }, [editor]);

  return null;
}

export function CodeActionMenuPlugin() {
  const [editor] = useLexicalComposerContext();

  // Simplified code action plugin - registers code language handling
  useEffect(() => {
    return editor.registerMutationListener(
      CodeNode,
      (mutations) => {
        // Handle code node mutations if needed
      }
    );
  }, [editor]);

  return null;
}
